import { useToast } from '../../../../../../state-management/contexts/ToastContext'
import { usePpfasGiftFundHandling } from '../../../../../ppfas-handling/usePpfasGiftFundHandling'
import { postPlanCta } from '../../fundExecutionHelpers'
import { useEnsureSipExecutionAllowed } from '../useEnsureSipExecutionAllowed'
import { EventNames } from '../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../utils/appBridge'
import { PlansExecutionEventIds, PlansScreen } from '../../../analytics/plansEvents'

export function usePlanSipStartAction(options?: { isRecommendationSheetSource?: boolean }) {
  const { showToast } = useToast()
  const { openPpfasGiftFund } = usePpfasGiftFundHandling(options)
  const ensureSipExecutionAllowed = useEnsureSipExecutionAllowed(options)

  async function onStartSip({
    isin,
    initiateSipCta,
    amount,
    fundName = ''
  }: {
    isin: string
    initiateSipCta?: unknown
    amount: number
    fundName?: string
  }) {
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ScreenName: PlansScreen.SipYourPlanRecommendation,
        eventId: PlansExecutionEventIds.SipStart,
        buttonLabel: 'Start SIP',
        ...(fundName ? { fundName } : {}),
        ...(isin ? { fundIsin: isin } : {})
      }
    })
    const openedPpfasGiftFund = await openPpfasGiftFund({
      isin,
      analyticsScreen: PlansScreen.SipYourPlanRecommendation
    })
    if (openedPpfasGiftFund) {
      return
    }
    const isAllowed = await ensureSipExecutionAllowed(isin, fundName)
    if (!isAllowed) return

    if (initiateSipCta == null || typeof initiateSipCta !== 'object') {
      postPlanCta(null, showToast)
      return
    }

    const inputData = {
      isin,
      amount: String(amount)
    }
    const filledCta = {
      ...(initiateSipCta as Record<string, unknown>),
      requestPayload: {
        inputData
      }
    }
    console.log('[plans-v4] filled execution CTA', filledCta)
    postPlanCta(filledCta, showToast)
  }

  return { onStartSip }
}
